// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2tZ-Y","row":"styles_row__3vEJ4"};